export default __webpack_public_path__ + "static/media/old-porto.69256646.png";